export const EXPECTATION_PROMPT_TEXT = {
  LABEL: "Prompt for SQL generation",
  TOOLTIP:
    "SQL generation is powered by analytical AI that may make mistakes. For more information, see our terms of service.",
  PLACEHOLDER:
    "Example: Write an Expectation that checks that sedan rides in Manhattan have no more than 4 passengers.",
  LOADING: "Generating SQL statement...",
  BUTTON: "Generate SQL",
} as const
